module.exports = __webpack_public_path__ + "media/newstyle/images/frete-gratis-8e7595102220559070c883069e87aab9.png";